<template>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--mypage is-hide">
            <header class="l-header l-header--top">
                <PublicPageHeader />
            </header>
            <section class="l-content-area">
                <div class="l-content">
                    <section class="p-bloc p-bloc--mypage">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">
                                <section class="p-mypage">
                                    <div class="p-mypage__content">
                                        <div class="mypage-content">
                                            <div class="p-mypage__page mypage-bloc">
                                                <div class="mypage-bloc__content">
                                                    <div class="page__bloc page__bloc--terms c-kiyaku">
                                                        <header class="article-header">
                                                            <h1>よくあるご質問</h1>
                                                        </header>

                                                        <!-- post -->
                                                        <section class="article-content">
                                                            <h3>新規登録に関する質問</h3>
                                                            <h5>Q. hubsynchユーザーアカウントは何歳から利用できますか？</h5>
                                                            <p>hubsynchユーザーアカウントの作成は、何歳からでも作成していただくことができます。ただし、サービスによっては年齢制限等がございます。各サービスサイトにおける規約に従ってください。
                                                            </p>
                                                            <h5>Q. hubsynchユーザーアカウントでは複数の住所を登録できますか？</h5>
                                                            <p>マイページや決済確認ページで住所を複数登録することができます。各サービスサイトの決済確認ページで配送先住所を指定することができます。
                                                            </p>
                                                            <h3>アカウント管理に関する質問</h3>
                                                            <h5>Q. <span
                                                                    style="font-size: 18px;">パスワードを忘れた場合、どのようにすればよいですか？</span>
                                                            </h5>
                                                            <p>各サービスサイトのhubsynchログイン画面に「パスワードを忘れた方はこちら」のボタンがありますので、そちらでご登録のメールアドレスを入力してください。その後、「パスワード再設定ページＵＲＬのお知らせ」というメールが届きますので、メール内容にそってパスワード再設定手続をしてください。
                                                            </p>
                                                            <h5>Q. ID（メールアドレス）を忘れた場合、どのようにすればよいですか？</h5>
                                                            <p>ID(メールアドレス）を忘れた場合は、<a
                                                                    href="/contactus"
                                                                    target="_blank">お問合せフォーム</a>より、以下必要事項をご記入の上、ご連絡ください。
                                                            </p>
                                                            <p><strong>【必要事項】</strong><br>
                                                                ・氏名<br>
                                                                ・生年月日<br>
                                                                ・ご住所<br>
                                                                ・ご利用のサービスサイト名、またはサイトURL</p>
                                                            <p>本人確認がとれた場合、サポートセンターからID（メールアドレス）をご連絡いたします。また、本人確認がとれなかった場合は、ID（メールアドレス）をお教えすることはできません。あらかじめご了承ください。
                                                            </p>
                                                            <h5>Q.
                                                                hubsynchユーザーアカウントに登録した氏名・住所等のユーザー情報を変更したい場合、どのようにすればよいですか？
                                                            </h5>
                                                            <p>各サービスサイトのマイページから登録情報変更をしていただくことができます。</p>
                                                            <h5>Q. hubsynchユーザーアカウントを退会するにはどうすればよいですか？</h5>
                                                            <p>各サービスサイトのマイページから退会することができます。ただし、退会した場合、登録情報や購入履歴等を引き継いだ状態で再度加入することはできませんのでご注意ください。また、各サービスサイトの有料課金をしている場合、すべて退会扱いになるのでご注意ください。<br>
                                                                ※一部退会申請がわかりづらいサービスサイトがございますので、ご不明の場合は、<a
                                                                    href="/contactus"
                                                                    target="_blank">お問合せフォーム</a>からご連絡ください。</p>
                                                            <h3>支払いと料金に関する質問</h3>
                                                            <h5>Q. hubsynchの決済はどの通貨に対応していますか？</h5>
                                                            <p>現在、日本円のみの対応となっております。あらかじめご了承ください。</p>
                                                            <h5>Q. hubsynchでの支払い完了を確認するにはどのようにすればよいですか？</h5>
                                                            <p>各サービスサイトのマイページ、購入履歴から確認していただくことができます。また、支払完了した際、随時ご登録のメールアドレス宛に通知をいたします。
                                                            </p>
                                                        </section>
                                                        <!-- -->
                                                        <!-- btn-contact -->
                                                        <div id="btn-contact-wrap" class="btn-wrap">
                                                            <p class="txt">ご不明な点がございましたら、お問合せフォームからご連絡ください。</p>
                                                            <p class="btn"><router-link :to="{ name: 'contact.us' }">お問合せ</router-link></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
            <Footer v-if="isLoggedIn"/>
            <PublicFooter v-else/>
        </div>
    </div>

</template>
<script setup>
import PublicPageHeader from "@/components/PublicPageHeader.vue";
import { ref, onBeforeMount } from "vue";
import { useSessionStore } from "@/stores/sessionStore";
import Footer from "@/components/Footer.vue";
import PublicFooter from "@/components/PublicFooter.vue";

const sessionStore = useSessionStore();
const isLoggedIn = ref(false);
onBeforeMount(async () => {
    isLoggedIn.value = sessionStore.isLoggedIn();
});
</script>